module.exports = __webpack_public_path__ + "static/img/wirecutter.ba34872.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/entry/images/wirecutter.svg
// module id = 9ZcF
// module chunks = 12